var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenuPre2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.603 15.6289V0H22.728V2.00024H10.272V0H8.39697V15.6289C7.29663 16.3145 6.5625 17.5347 6.5625 18.9238V32H8.4375V24.9719H24.5623V32H26.4373V18.9236C26.4373 17.5347 25.7031 16.3145 24.603 15.6289ZM8.4375 18.9236C8.4375 17.8181 9.33691 16.9187 10.4424 16.9187H22.5574C23.6628 16.9187 24.5623 17.8181 24.5623 18.9236V19.4648H8.4375V18.9236ZM22.728 9.45947H10.272V3.87524H22.728V9.45947ZM10.272 11.3345H22.728V15.0481C22.6714 15.0457 22.6147 15.0437 22.5574 15.0437H10.4424C10.3853 15.0437 10.3286 15.0457 10.272 15.0481V11.3345ZM24.5623 23.0969H8.4375V21.3398H24.5623V23.0969Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenuPre2);
export default __webpack_public_path__ + "static/media/venuPre2.1e61d3afe07aeb57889ab8ffdd843e2f.svg";
export { ForwardRef as ReactComponent };